import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {
  ModalSubtitle,
  ModalTitle,
  StyledModal,
  StyledModalContent,
  StyledModalText,
  StyledModalTextColored,
  StyledUl,
  StyledModalTextBold,
  StyledNewButton,
} from "./CompanyDuplicateModal.styled";
import { getCompanyDuplicateModal } from "../../reducers/companyDuplicateModalSlice";

const CompanyDuplicateModal = ({ onClose, isMobile }) => {
  const { page_content, loading } = useSelector(
    (state) => state.companyDuplicateModal
  );

  const { country_name: countrySelected } = useSelector((state) => state.form);
  const { value: languageCode } = useSelector((state) => state.languageOptions);

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getCompanyDuplicateModal(countrySelected, languageCode));
  }, [countrySelected, dispatch, languageCode]);

  React.useEffect(() => {
    if (window.digitalData) {
      window.digitalData.push({
        event: {
          name: "click",
          category: "pop-up",
          label: "registration-error|company-already-registered",
          action: "open",
        },
      });
    }
  }, []);

  return (
    !loading && (
      <StyledModal onClose={() => onClose()} isMobile={isMobile}>
        <StyledModalContent>
          <ModalTitle>{page_content?.header}</ModalTitle>
          <ModalSubtitle>{page_content?.contact_person_header}</ModalSubtitle>
          <StyledModalText>
            {page_content?.contact_person_text}{" "}
            <StyledModalTextColored to="/add-contact-person">
              {page_content?.contact_person_label_link}
            </StyledModalTextColored>
          </StyledModalText>
          <ModalSubtitle>{page_content?.text_with_list?.message}</ModalSubtitle>
          <StyledUl>
            {page_content?.text_with_list?.list_of_text_fields.map((item) => (
              <li key={item?.item_text}>{item?.item_text}</li>
            ))}
          </StyledUl>
          <StyledModalTextBold>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {page_content?.contact_block}
            </ReactMarkdown>
          </StyledModalTextBold>
          <StyledNewButton
            data-cy="company-duplicate-modal-understand-button"
            text={page_content?.understand_button?.label}
            isMobile={isMobile}
            onClick={() => onClose()}
          />
        </StyledModalContent>
      </StyledModal>
    )
  );
};

CompanyDuplicateModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default CompanyDuplicateModal;
